module.exports = __webpack_public_path__ + "static/media/isophya_camptoxypha.27ac2969.jpg";